import { DotLottieReact, type DotLottieReactProps } from '@lottiefiles/dotlottie-react';
import { useEffect, useState } from 'react';

interface Props extends DotLottieReactProps {
  // use this prop if lottie animation playing on modal open -> set delay to recommend
  delay?: number | boolean;
  size?: number; // Optional size prop to control the size of the animation
  style?: React.CSSProperties; // Optional style prop to override default styles
  // public/animations/${src}.lottie -> pass src prop - to use specific path
  name: string;
}

const RECOMMEND_DELAY_TO_MODAL_OPEN = 850; // ms

export const LottieAnimation: FC<Props> = ({ delay, size, style, name, ...props }) => {
  const [canPlay, setCanPlay] = useState(!delay);

  const defaultStyles = size ? { width: size, height: size } : { width: 75, height: 75 };

  useEffect(() => {
    if (!delay || canPlay) return;
    const tid = setTimeout(() => setCanPlay(true), typeof delay === 'number' ? delay : RECOMMEND_DELAY_TO_MODAL_OPEN);
    return () => clearTimeout(tid);
  }, [delay, canPlay]);

  if (!canPlay) return null;

  return (
    <DotLottieReact
      style={{ ...defaultStyles, ...style }}
      layout={{ fit: 'cover' }}
      src={`/animations/${name}.lottie`}
      autoplay
      {...props}
    />
  );
};
